/* @Mau de Pallares */
/* SUIM V 2.0 */
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class SpecialityAddOnRequest extends MainRequest {

    // static addAntecedent(data, token) {
    //     return this.postSEC(ServicePath.ANTECEDENT_ADD, data, token)
    // }
    static addAntecedentTemp(data) {
        return this.postSEC(ServicePath.ANTECEDENT_ADD_TEMP, data);
    }
    
    static listSpecialityOnRegister(data) {
        return this.postSEC(ServicePath.LIST_SPECIALITY_ONREGISTER, data);
    }

    static allAntecedent(token) {
        return this.getSEC(ServicePath.ANTECEDENT_LIST_ALL, token)
    }

    static updateAntecedent(data, token) {
        return this.postSEC(ServicePath.ANTECEDENT_UPDATE, data, token)
    }

    static deleteAntecedent(data, token) {
        return this.postSEC(ServicePath.ANTECEDENT_DELETE, data, token)
    }

}